import { action, makeObservable, observable } from "mobx";
import OrganisationsApi, {
  OrganisationsApi as IOrganisationsApi
} from "../../../../../services/api/v2/organisations/Organisations.api";
import PermissionsContext from "../../../../../contexts/permissions/PermissionsContext";
import { PermissionFields } from "../../../../../contexts/permissions/PermissionsTypes";
import I18n from "../../../../localization/I18n";
import { IModalContextModel } from "../../../context/IModalContext";
import ModalContext from "../../../context/ModalContext";
import { UiActionRenderers } from "../../../../uiAction/IUiAction";
import { BaseModel } from "../../../../util/BaseModel";
import ImpactTypesApi, {
  ImpactTypesApi as IImpactTypesApi
} from "../../../../../services/api/v2/impactTypes/ImpactTypes.api";
import ImpactsApi, { ImpactsApi as IImpactsApi } from "../../../../../services/api/v2/impacts/Impacts.api";
import { getImpactTypesSidebarFormFields } from "./ImpactTypesSidebar_fields";
import { SingleFormModel } from "../../../../../pages/change/forms/singleFormModel/SingleForm_model";

export class ImpactTypesSidebarModel extends BaseModel {
  impactTypesProvider: IImpactTypesApi;
  impactsProvider: IImpactsApi;
  modalService: IModalContextModel;
  organisationsProvider: IOrganisationsApi;
  @observable isLoading: boolean = true;
  @observable.ref impact: FP.Entities.IImpact;
  organisationId: number;
  projectId: number;
  @observable impactTypesData: FP.Entities.ITreeDataItem[];
  canEdit: boolean;
  @observable.ref formModel: SingleFormModel;
  onSubmit: (impactTypeIds: number[]) => void;
  actions = [
    {
      id: "action1",
      label: I18n.t("phrases.done"),
      onAction: ev => {
        this.submitForm();
      },
      componentProps: {
        className: "ml-auto"
      },
      rendersIn: UiActionRenderers.BUTTON
    }
  ];
  currentIds: number[];

  constructor(
    organisationId: number,
    projectId: number,
    onSubmit: (impactTypeIds: number[]) => void,
    currentIds: number[]
  ) {
    super();
    makeObservable(this);
    this.impactTypesProvider = ImpactTypesApi;
    this.organisationsProvider = OrganisationsApi;
    this.organisationId = organisationId;
    this.modalService = ModalContext;
    this.onSubmit = onSubmit;
    this.currentIds = currentIds;
    this.projectId = projectId;
    this.impactsProvider = ImpactsApi;
    this.loadSidebar();
    this.canEdit = PermissionsContext.canEditField(PermissionFields.IMPACTS, this.organisationId, this.projectId);
  }

  submitForm = async () => {
    let res = await this.formModel.submit();
    this.onSubmit(res.impactTypes);
    this.modalService.hide();
  };

  @action
  getOrgImpactTypes = async () => {
    let res = await this.impactTypesProvider.getImpactTypes(this.organisationId, {
      page: 1,
      pageSize: 100000,
      filters: `lifecycleStatus==0`
    });

    if (!res || res.isError) return;
    let k = res.payload.map(e => {
      return { ...e, label: e.name, parent: 0 };
    });
    this.impactTypesData = k as any[];
  };

  @action
  loadSidebar = async () => {
    this.setIsLoading(true);
    await this.getOrgImpactTypes();
    this.formModel = new SingleFormModel();
    this.formModel.formFields = getImpactTypesSidebarFormFields(this.impactTypesData, this.currentIds);
    this.formModel.actions = this.actions;
    this.setIsLoading(false);
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };
}
